import { empConst } from '@/utils/constants';
const getters = {
  // user
  userNIFCIF: state => state.user.userNIFCIF,
  userName: state => state.user.name,
  empresas: state => state.user.empresas,
  userAuthenticated: state => state.user.authenticated,
  roles: state => state.user.roles,
  rolesUsuario: (state, getters) => {
    var result = getters.roles.map(function(rol) {
      var nombresRol = rol.split('_');
      return nombresRol[nombresRol.length - 1];
    });
    return result;
  },

  // app
  sessionExpired: state => state.app.sessionExpired,
  environment: state => state.app.environment,
  menuSelected: state => state.app.menuSelected,
  empresaSelected: state => state.app.empresaSelected,
  isGasElectricidad: (state, getters) => {
    return (
      getters.empresaSelected != null &&
      (getters.empresaSelected.cdtipemp === empConst.TIPO_GAS ||
        getters.empresaSelected.cdtipemp === empConst.TIPO_ELE)
    );
  },
  browserInfo: state => state.user.browserInfo,
  breadcrumb: state => state.app.breadcrumb,
  masterTablesLoaded: state => state.app.masterTablesLoaded,
  timeLastAPICall: state => state.app.timeLastAPICall,
  loading: state => state.app.loading,
  versionApi: state => state.user.versionApi,
  entorno: state => state.user.entorno,
  // catalogs
  tipoEmpresas: state => state.catalogs.tipoEmpresas,
  datosBancarios: state => state.catalogs.datosBancarios,
  provincias: state => state.catalogs.provincias
};

export default getters;
